import styled from 'styled-components'

import { FieldSkeleton } from '@/components/layout/field-row'
import { media } from '@/theme/common'

// Note: same box as the loaded photo (FieldPhotoImage): 10rem, rounded square
export const PhotoSkeleton = styled(FieldSkeleton)(({ theme }) => ({
  borderRadius: theme.border.radius['12'],
  height: '10rem',
  width: '10rem',
}))

export const OfferLink = styled.a({
  '&:hover': {
    textDecoration: 'underline',
  },
  display: 'block',
  minWidth: 0,
})

// Note: 1.5x the default 16rem table filter width; a `&&` wrapper outranks the table's own
// `> *` width rule without an inline style
export const CategoryFilter = styled.div`
  && {
    flex-shrink: 0;
    width: 24rem;
    max-width: 100%;

    ${media.down('sm')} {
      width: 100%;
    }
  }
`
